import { defineComponent as _defineComponent } from 'vue'
import { User } from "@/CodegenTypes";
import { startCase } from "lodash";

import IntakeSettingFormModal from "@/components/modules/account/IntakeSettingFormModal.vue";
import { computed, ref } from "vue";
import { useTranslation } from "@/store/translation";
import { FEATURE_TOGGLES } from "@/config";


export default /*#__PURE__*/_defineComponent({
  __name: 'DdProfile',
  props: {
    user: null
  },
  setup(__props: any) {

const props = __props as { user: User };


const showIntakeSettingModal = ref(false);

const { $t } = useTranslation();


const showCompanyPl = computed(() => {

  return props.user?.roleName !== "member";
})

const showPlaceoutPl = computed(() => {

  return props.user?.roleName !== "member";
})

const showIntake = computed(() => {

  return props.user?.ddCanIntake && props.user?.ddIntake;
})


function formatBoolean(bool: boolean) {
  return bool ? "Yes" : "No";
}

return { __sfc: true,props, showIntakeSettingModal, $t, showCompanyPl, showPlaceoutPl, showIntake, formatBoolean, startCase, IntakeSettingFormModal, FEATURE_TOGGLES }
}

})